import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Header.module.css';
import navBarIcon from '../images/Nav Bar Icon.png';
import HamburgerIcon from './HamburgerIcon';

const Header = () => {
  return (
    <header className={styles.header}>
      <HamburgerIcon />
      <Link to="/">
        <img src={navBarIcon} alt="Nav Bar Icon" className={styles.navBarIcon} />
      </Link>
      <Link to="/">
        <div className={styles.myImage} role="img" aria-label="A description of the image"></div>
      </Link>
      <nav className="navigation">
        <ul className={styles.navList}>
          <li className={styles.dropdown}>
            <Link to="/about" className={styles.navLink}>ABOUT</Link>
            <ul className={styles.dropdownMenu}>
              <li><Link to="/team" className={styles.dropdownLink}>TEAM</Link></li>
            </ul>
          </li>
          <li><Link to="/services" className={styles.navLink}>SERVICES</Link></li>
          <li><Link to="/work" className={styles.navLink}>WORK</Link></li>
          <li><Link to="/join" className={styles.navLink}>JOIN</Link></li>
          <li><Link to="/connect" className={styles.navLink}>CONNECT</Link></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header; 